import cookieConsent from './cookie-consent'
import trackingConsent from './tracking-consent'

export default {
    cookieConsent,
    trackingConsent
}
